// we declare valid values that can render
enum AcceptedDexValues {
  PRINT_EXTENDED = 'PrintDexExtended',
}

export default AcceptedDexValues;
